import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Appointment } from "../shared/models/appointment";
import { DataStoreService } from "../shared/services/api/data-store.service";
import * as moment from "moment";

@Injectable()
export class EventsResolverService implements Resolve<Appointment[]> {
  constructor(private dataStore: DataStoreService) {
  }

  private cached: Appointment[] = null;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Appointment[]> | Promise<Appointment[]> | Appointment[] {
    if (this.cached != null) {
      return this.cached;
    }
    return this.dataStore.findAll(Appointment, {
        filter: {
          start: moment().startOf('month').toISOString(),
          end: moment().endOf('month').toISOString(),
          all: true
        }
      }
    ).map(doc => doc.getModels())
      .do(models => this.cached = models);
  }


}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/calendar/events-resolver.service.ts